module.exports = __webpack_public_path__ + "img/ani_test_atlas_P_10.927c9da0.png";